import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { SingleProduct } from './pages/SingleProduct';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { RequestFlowersPage } from './pages/RequestFlowersPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<App data-id="element-14" />} data-id="element-13" />
        <Route path="/shop" element={<Shop data-id="element-16" />} data-id="element-15" />
        <Route path="/product/:id" element={<ProductDetail data-id="element-18" />} data-id="element-17" />
        <Route path="/featured-product" element={<SingleProduct data-id="element-20" />} data-id="element-19" />
        <Route path="/login" element={<Login data-id="element-22" />} data-id="element-21" />
        <Route path="/signup" element={<Signup data-id="element-24" />} data-id="element-23" />
        <Route path="/cart" element={<Cart data-id="element-26" />} data-id="element-25" />
        <Route path="/checkout" element={<Checkout data-id="element-28" />} data-id="element-27" />
        <Route path="/how-it-works" element={<HowItWorksPage data-id="element-30" />} data-id="element-29" />
        <Route path="/request-flowers" element={<RequestFlowersPage data-id="element-32" />} data-id="element-31" />
      </Routes>
    </BrowserRouter>;
}